import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-career-portal-layout',
  templateUrl: './career-portal-layout.component.html',
  styleUrls: ['./career-portal-layout.component.scss']
})
export class CareerPortalLayoutComponent implements OnInit {
  isShow: boolean;
  topPosToStartShowing = 1000;
  public innerWidth: any;

  constructor(public router: Router) {
    this.router.url
  }

  ngOnInit(): void {
    //the variable innerWidth is assigned with the window's innerWidth
    if (window.innerWidth > 1024) {
      this.innerWidth = true
    }
    else {
      this.innerWidth = false
    }
  }


  //On window resize this method is called
  //the new innerWidth is stored to variable innerWidth
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth > 1024) {
      this.innerWidth = true
    }
    else {
      this.innerWidth = false
    }
  }
  // Checks the scroll position and makes the go to top button visible if scroll goes beyond the start showing position
  @HostListener('window:scroll')
  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  //Defines the scroll on button click
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
